import React from 'react';
import { isValidEmail } from './Utils';

function PreorderModal({
  firstName, onFirstNameChange,
  email, onEmailChange,
  bookLabel,
  submitted,
  loading,
  error,
  onSubmit,
  onClose,
}) {
  return (
    <div
      className="confirm-overlay"
      onClick={(e) => { if (e.target.classList.contains('confirm-overlay')) onClose(); }}
    >
      <div className="confirm-modal theme-bwgo preorder-modal">
        <button className="confirm-close-icon" onClick={onClose} aria-label="Close">✕</button>
        <div className="confirm-bar" />
        <div className="confirm-body">
          {!submitted ? (
            <>
              <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>📦</div>
              <span className="confirm-pill">Coming Soon</span>
              <h2 className="confirm-title">Be the first to know</h2>
              <p className="confirm-book-title" style={{ opacity: 0.75, marginBottom: '1.4rem' }}>{bookLabel}</p>
              <p className="preorder-desc">
                Available once Before We Get Older 3rd edition launches — we'll notify you as soon as it's ready.
              </p>
              <input
                type="text"
                placeholder="First name *"
                value={firstName}
                onChange={onFirstNameChange}
                className="preorder-input"
                aria-label="First name"
              />
              <input
                type="email"
                placeholder="Email address *"
                value={email}
                onChange={onEmailChange}
                onKeyDown={(e) => e.key === 'Enter' && onSubmit()}
                className="preorder-input"
                aria-label="Email address"
              />
              {error && (
                <p
                  style={{ color: '#ffb3b3', fontSize: '0.85rem', margin: '0 0 0.8rem', textAlign: 'center' }}
                  aria-live="polite"
                >
                  ⚠️ {error}
                </p>
              )}
              <button
                onClick={onSubmit}
                disabled={loading || !firstName.trim() || !email.trim() || !isValidEmail(email)}
                className="preorder-submit-btn"
              >
                {loading ? 'Saving...' : 'Notify me 🔔'}
              </button>
            </>
          ) : (
            <>
              <div style={{ fontSize: '3rem', marginBottom: '0.8rem' }}>🎉</div>
              <span className="confirm-pill">You're on the list!</span>
              <h2 className="confirm-title">We'll let you know, {firstName}!</h2>
              <p className="preorder-desc">
                As soon as <strong>{bookLabel}</strong> is ready, you'll hear about it at <strong>{email}</strong>.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default PreorderModal;